export default function MySQL_ASIN() {
  return (
    <div>
      <h2>MySQL_ASIN</h2>    </div>
  );
}